import { Provider, type Account } from '@repo/api-gw-sdk';

import { useDAL } from '@/contexts/useDAL';
import { createCombineCondition } from '@/types/advanceFilter';

import { getMrapPolicyJson } from './byovPolicyUtils';

import { createCloudProviderCondition } from '../cloudProviders/createCloudProviderCondition';
import { convertQuery } from '../cost-explorer/utils/queryUtils';
import { Loader } from '../layout/loading';
import { CopyableCode } from '../shared/copyableCode';

export const MrapCopyablePolicy = ({
  mrapAlias,
  vaultAccount,
}: {
  mrapAlias: string;
  vaultAccount: Account | undefined;
}) => {
  const dal = useDAL();
  const { data: restoreAccountsBody, isLoading } =
    dal.cloudAccounts.restore.useList(undefined, undefined, {
      filters: convertQuery(
        createCombineCondition([createCloudProviderCondition([Provider.Aws])])
      ),
    });

  if (isLoading) {
    return <Loader />;
  }

  const restoreAccounts = restoreAccountsBody?.accounts ?? [];
  const policy = getMrapPolicyJson(mrapAlias, vaultAccount, restoreAccounts);

  return (
    <CopyableCode
      title='mrap-policy.json'
      code={policy}
      maxHeight='320px'
      blur={!mrapAlias || restoreAccounts.length === 0}
    />
  );
};
